import { Box, IconButton, Tooltip } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import LogoutContainer from "../../Layout/LogoutContainer";
import {
  HeaderRightContent,
  PageTitleSubtitle,
  StyledHeader,
} from "../../Common/styles/header";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { openHelp } from "../../../Redux/reducers/helpSlice";
import { platformAdminPermissions } from "../../../utils/roles";
import EmailTemplatesList from "./EmailTemplatesList";

const EmailTemplates = () => {
  const { t } = useTranslation("email-templates");
  const { t: sidebarT } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const { platformPermissions } = useAppSelector((state) => state.user);
  const canSync = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions],
  );

  return (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <StyledHeader>
        <PageTitleSubtitle title={t("PAGE_TITLE")} subtitle={t("PAGE_SUBTITLE")} />
        <Box sx={HeaderRightContent}>
          <Tooltip title={sidebarT("HELP_TOOLTIP")}>
            <IconButton onClick={() => dispatch(openHelp("email-templates"))} size="small">
              <HelpOutline />
            </IconButton>
          </Tooltip>
        </Box>
      </StyledHeader>
      <Box sx={{ p: 5, height: "calc(100% - 154px)", overflow: "auto" }}>
        <EmailTemplatesList canSync={canSync} />
      </Box>
    </>
  );
};

export default EmailTemplates;
